import { formatPenalidadTooltip } from "./gestor-centralizado.formatters";

export const GESTOR_IGV_RATE = 0.18;

export function recalculateRowCosts(row = {}) {
  const cantidad = Number(row.cantidad ?? 1) || 1;
  const costoSinIgv = Number(row.costoSinIgv ?? row.costoTotalSinIgv ?? 0);
  const costoConIgv = Number((costoSinIgv * (1 + GESTOR_IGV_RATE)).toFixed(2));
  const totalSinIgv = Number((costoSinIgv * cantidad).toFixed(2));
  const totalConIgv = Number((costoConIgv * cantidad).toFixed(2));

  return {
    costoSinIgv,
    costoConIgv,
    totalSinIgv,
    totalConIgv,
    costoTotalSinIgv: costoSinIgv,
    costoTotalConIgv: costoConIgv,
    totalFacturarSinIgv: totalSinIgv,
    totalFacturarConIgv: totalConIgv,
  };
}

export function totalPenalidadRow(row = {}) {
  const penalidades = row.penalidades || [];
  if (!penalidades.length) {
    return Number(row.penalidad ?? 0);
  }

  return penalidades.reduce(
    (sum, item) => sum + Number(item.monto ?? 0),
    0,
  );
}

export function porcentajePenalidadRow(row = {}) {
  const penalidades = row.penalidades || [];
  if (!penalidades.length) return 0;
  return Number(penalidades[0].porcentaje ?? 0);
}

export function tooltipPenalidadesRow(row = {}) {
  return formatPenalidadTooltip(row);
}

export function hasPenalidadDisplay(row = {}) {
  if (totalPenalidadRow(row) > 0) return true;
  return Boolean(formatPenalidadTooltip(row));
}

export function computeTotalAFacturar(items = []) {
  let totalServicios = 0;
  let totalPenalidades = 0;

  for (const row of items) {
    totalServicios += Number(row.totalSinIgv ?? row.totalFacturarSinIgv ?? 0);
    totalPenalidades += totalPenalidadRow(row);

    for (const detalle of row.detalles || []) {
      totalServicios += Number(detalle.totalSinIgv ?? 0);
    }
  }

  return Number((totalServicios - totalPenalidades).toFixed(2));
}
